import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import { CalendarManagemantIndex, MainInformation, SecurityIncidentIndex, ServiceLevels, StandardInformation, TrainingCalendarIndex, VendorManagementIndex } from "../pages/Information";
import PageNotFound from "../components/View/PageNotFound";
import TaskManagementIndex from "../pages/Information/TaskManagement";
import { Wrapper } from "../utils/RolesandAccess";

function InformationRoutes() {
  const { stdId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {

    if (location.pathname === `/standard/${stdId}/information/`||location.pathname === `/standard/${stdId}/information`) {
      navigate(`/standard/${stdId}/information/standard-information`, { replace: true });
    }
    console.log(stdId);
  }, [location.pathname, stdId, navigate]);
  return (
    <Routes>
      <Route path="/" element={ <Wrapper accessKey={stdId} Component={MainInformation} />}>
       <Route path="standard-information" element={<Wrapper accessKey={stdId} Component={StandardInformation} />} />
       <Route path="service-levels" element={<Wrapper accessKey={stdId} Component={ServiceLevels} />} />
       <Route path="task-management" element={<Wrapper accessKey={stdId} Component={TaskManagementIndex} />} />
       <Route path="vendor-management" element={<Wrapper accessKey={stdId} Component={VendorManagementIndex} />} />
       <Route path="security-incident" element={<Wrapper accessKey={stdId} Component={SecurityIncidentIndex} />} />
       <Route path="training-calendar" element={<Wrapper accessKey={stdId} Component={TrainingCalendarIndex} />} />
       <Route path="calendar-management" element={<Wrapper accessKey={stdId} Component={CalendarManagemantIndex} />} />
      </Route>
    <Route path="/*" element={<PageNotFound/>} />
    </Routes>
  )
}

export default InformationRoutes